/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Autofill_MessageInputs */

const en_profile_autofill_message = /** @type {(inputs: Profile_Autofill_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload your resume to automatically fill out your profile.`)
};

const de_profile_autofill_message = /** @type {(inputs: Profile_Autofill_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden Sie Ihren Lebenslauf hoch, um Ihr Profil automatisch auszufüllen.`)
};

/**
* | output |
* | --- |
* | "Upload your resume to automatically fill out your profile." |
*
* @param {Profile_Autofill_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_autofill_message = /** @type {((inputs?: Profile_Autofill_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Autofill_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_profile_autofill_message(inputs)
	return en_profile_autofill_message(inputs)
});